import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Form, Input, FormInstance } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';

import FloatingFormItem from '@/components/_common/FloatingFormItem';
import { CostCenterFormValues } from '@/core/domain/enterprise/CostCenter/CostCenter.types';

interface Props {
  form: FormInstance<CostCenterFormValues>;
}
function AccountsCostCentersGeneralForm({ form }: Props) {
  const intl = useIntl();

  const defaultEmptyFieldError = {
    required: true,
    message: <FormattedMessage id="commons.form.errors.requiredField" />,
  };

  return (
    <Form form={form} layout="vertical">
      <Row gutter={[8, 8]}>
        <Col flex="auto">
          <FloatingFormItem
            label={intl.formatMessage({
              id: 'costCenters.modal.general.form.description',
            })}
            name="description"
            rules={[defaultEmptyFieldError]}
          >
            <Input />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
}

AccountsCostCentersGeneralForm.propTypes = {
  form: PropTypes.object.isRequired,
};

export default AccountsCostCentersGeneralForm;
